<script setup lang="ts">
import { UiSnackbar } from "@packages/component-library";
import { computed, onBeforeMount } from "vue";
import { useSystemStore } from "@/store/system.store";
import { useRoute, useRouter } from "vue-router";
import { useUserStore } from "@/store/user.store";

const router = useRouter();
const route = useRoute();
const userStore = useUserStore();
const systemStore = useSystemStore();
const notification = computed(() => systemStore.notification);

onBeforeMount(async () => {
  await router.isReady();

  if (route.query.token) {
    localStorage.setItem("rcShowToken", route.query.token.toString());
    await router.replace({ name: route.name });
  }

  if (localStorage.rcShowToken) {
    userStore.getUserInformation();
  }
});
</script>

<template>
  <Transition name="notification">
    <UiSnackbar
      v-if="notification"
      :type="notification.type"
      :text="notification.text"
      :title="notification.title"
      class="notification"
      @close="systemStore.hideNotification()"
    />
  </Transition>
  <RouterView />
</template>

<style lang="scss" scoped>
.notification {
  position: fixed;
  top: 88px !important;

  @media (width < 1024px) {
    right: 16px !important;
  }
}

.notification-enter-active {
  transition: all 0.3s ease-out;
}

.notification-leave-active {
  transition: all 0.8s ease-out;
}

.notification-enter-from,
.notification-leave-to {
  transform: translateX(400px);
  opacity: 0;
}
</style>
